import React from 'react';
import './HomeTabGroup.css';

export interface HomeTabGroupProps {
  label: string;
  open: boolean;
  active: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

export const HomeTabGroup: React.FC<HomeTabGroupProps> = ({
  label,
  open,
  active,
  onToggle,
  children,
}) => {
  return (
    <div className={`home-tab-group${open ? ' home-tab-group--open' : ''}`}>
      <button
        type="button"
        className={`home-tab-group__header${active ? ' home-tab-group__header--active' : ''}`}
        onClick={onToggle}
        aria-expanded={open}
      >
        <span
          className={`home-tab-group__chevron${open ? ' home-tab-group__chevron--open' : ''}`}
          aria-hidden
        />
        <span className="home-tab-group__label">{label}</span>
        {active && !open && <span className="home-tab-group__dot" aria-hidden />}
      </button>
      {open && <div className="home-tab-group__tabs">{children}</div>}
    </div>
  );
};

/** 公開 RAG 時だけ大枠で包む。それ以外は children をそのまま出す。 */
export const OptionalHomeTabGroup: React.FC<HomeTabGroupProps & { enabled: boolean }> = ({
  enabled,
  children,
  ...props
}) => {
  if (!enabled) return <>{children}</>;
  return <HomeTabGroup {...props}>{children}</HomeTabGroup>;
};

export default HomeTabGroup;
